import { normalizeWhitespace } from '@cli-utils/text.js'

export function isPlainNextDevScript(devScript: string): boolean {
  const normalized = normalizeWhitespace(devScript)
  return (
    normalized === 'next dev' ||
    normalized === 'next dev --turbopack' ||
    normalized === 'next dev --turbo'
  )
}
